module.exports = "/_next/static/images/Beyond-181b94b3fedbe2856d942eaef41f0e5b.png";